export { default } from './WhatIsWhatQuestionContainer';
